export const statusOptions = [
  { value: 'all', label: 'All Statuses' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Processing', label: 'Processing' },
  { value: 'Queued', label: 'Queued' },
];

export const reportTypeOptions = [
  { value: 'all', label: 'All Report Types' },
  { value: 'HIPAA_COMPLIANCE', label: 'HIPAA Compliance Report' },
  { value: 'NIST_800_171', label: 'NIST 800-171 Compliance Report' },
  { value: 'GENERAL_SECURITY', label: 'General Security Report' },
  { value: 'EXECUTIVE_REPORT', label: 'Executive Summary' },
  { value: 'MONTHLY_SERVICE_REVIEW', label: 'Monthly Service Review' },
  { value: 'VULNERABILITY_REPORT', label: 'Vulnerability Report' },
  { value: 'SOC_EVENTS_REPORT', label: 'SOC Events Report' },
  { value: 'ESCALATED_CASES_REPORT', label: 'Escalated Cases Report' },
  { value: 'SLA_ADHERENCE_DATA_REPORT', label: 'SLA Adherence Report' },
  { value: 'O365_ACCOUNT_ACTIVITY_REPORT', label: 'O365 Account Activity Report' },
  { value: 'XDR_INGESTION_DATA_REPORT', label: 'XDR Ingestion Report' },
  { value: 'WINDOW_ACCOUNT_ACTIVITY_REPORT', label: 'Windows Account Activity Report' },
  { value: 'AZURE_DEVICE_ACTIVITY_REPORT', label: 'Azure Device Activity Report' },
];
